import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Alert add/edit form component.
 *
 * @namespace tmrAdminAlertForm
 * @type {ngComponent}
 */
export const tmrAdminAlertForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminAlertFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminAlertForm}.
 *
 * @type {ngController}
 */
export class tmrAdminAlertFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    tmrAlertLevels,
    tmrAlertTargets,
    tmrLanguages
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { tmrAlertLevels, tmrAlertTargets, tmrLanguages })
  }

  $onInit() {
    super.$onInit()

    // Create getters/setters for each active language.
    this.message = {}
    Object.keys(this.tmrLanguages.languages).forEach(
      langcode =>
        (this.message[langcode] = newValue =>
          this.getSetMessage(newValue, langcode))
    )

    this._date = {}
    this._eventDate = {}
  }

  get date() {
    return Object.assign(this._date, {
      from: this.resource.startDate,
      to: this.resource.endDate,
    })
  }

  set date({ from: startDate, to: endDate }) {
    Object.assign(this.resource, { startDate, endDate })
  }

  get eventDate() {
    return Object.assign(this._eventDate, {
      from: this.resource.startEventDate,
      to: this.resource.endEventDate,
    })
  }

  set eventDate({ from: startEventDate, to: endEventDate }) {
    Object.assign(this.resource, { startEventDate, endEventDate })
  }

  getSetMessage(newValue, langcode) {
    if (newValue === undefined) return this.getMessage(langcode)
    this.setMessage(newValue, langcode)
  }

  getMessage(langcode) {
    return this.resource.$getMessage(langcode)
  }

  setMessage(newValue, langcode) {
    this.resource.$setMessage(newValue, langcode)
  }

  /** @override */
  onSubmit() {
    this.resource.roles = this.resource.roles.map(role => {
      try {
        return { id: role.id }
      } catch (Exeption) {
        // Nel caso non sia un JSON ma una stringa viene fatto il parsing a JSON
        return { id: JSON.parse(role).id }
      }
    })
    super.onSubmit()
  }
}
